export const MEAL_STATUSES = {
  UNAVAILABLE: "unavailable",
  AVAILABLE: "available",
  FARE_CATEGORY_UNSUPPORTED: "fare_category_unsupported",
  PICKED: "picked",
  ORDERED: "ordered",
}

export const SUBMIT_MEALS_ORDER = "meals/orderMeals"
export const SUBMIT_MEALS_ORDER_FAILURE = "meals/orderMeals_FAILURE"
